import Address from "domain/address";
import FcmAccount from "features/fcmAccounts/fcmAccount";

export default class AddMerchantRequest {
    name: string;
    address: Address;
    fcmAccounts: FcmAccount[];
    admin: MerchantAdmin;
    additionalAdmins: MerchantAdmin[];
    phone: string;
    email:string;
    websiteUrl: string;
    giveUpFee: number;
}

export class MerchantAdmin {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}